import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	issues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	issues: {
		id: 'issue-table-grouping.group-row.group-header.issues',
		defaultMessage: '{count, plural, one {# issue} other {# issues}}',
		description: 'Text for the issue count for each group in the issue table',
	},
	issuesIssueTermRefresh: {
		id: 'issue-table-grouping.group-row.group-header.issues-issue-term-refresh',
		defaultMessage: '{count, plural, one {# work item} other {# work items}}',
		description: 'Text for the issue count for each group in the issue table',
	},
});
export default messages;
